import { MemoryArrowDownIcon } from './MemoryArrowDownIcon';

/**
 * author: Michael Irigoyen
 * id 6F7286C3-4653-4443-A5A4-400D42A101C5
 * name memory-arrow-down
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/memory-arrow-down.svg
 * tags
 */
export const ChipArrowDownIcon = MemoryArrowDownIcon;
export default ChipArrowDownIcon